export const TEST_ID = 'themeProvider';
